// from https://stackoverflow.com/a/49950777

const concatenateUint8Arrays = (a, b) => {
    const result = new Uint8Array(a.length + b.length);
    result.set(a, 0);
    result.set(b, a.length);
    return result;
};

const convertToCsv = (fName, rows) => {
    let csv = '';
    for (var i = 0; i < rows.length; i++) {
        const row = rows[i];
        for (let j = 0; j < row.length; j++) {
            let val = row[j] === null ? '' : row[j].toString();
            val = val.replace(/\t/gi, ' ');
            val = `"${val.replace(/"/gi, `""`)}"`;
            if (j > 0) csv += '\t';
            csv += val;
        }
        csv += '\n';
    }

    // for UTF-16
    let cCode;
    const chunkSize = 1048576;
    let chunk = [];
    let bArr = new Uint8Array();
    chunk.push(255, 254);
    for (var i = 0; i < csv.length; ++i) {
        cCode = csv.charCodeAt(i);
        chunk.push(cCode & 0xff);
        chunk.push((cCode / 256) >>> 0);
        if (chunk.length >= chunkSize) {
            bArr = concatenateUint8Arrays(bArr, new Uint8Array(chunk));
            chunk = [];
        }
    }
    bArr = concatenateUint8Arrays(bArr, new Uint8Array(chunk));

    const blob = new Blob([bArr], {
        type: 'text/csv;charset=UTF-16LE;',
    });
    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fName);
    } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = window.URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    }
};

export default convertToCsv;
